export default "__VITE_ASSET__Y3VMPT4s__"